export function error(state) {
  return state.error;
}

export function errorMessage(state) {
  return state.errorMessage;
}

export function getLevelImage(state) {
  return state.LevelImage;
}

export function getChildLevelNumber(state) {
  return state.userLevel['number'];
}

export function getChildLevelName(state) {
  return state.userLevel['name'];
}

export function getChildCoinsBanked(state) {
  return state.CoinsBanked;
}

export function getChildLevelPoints(state) {
  return state.userPoints;
}

export function getChildCoinsResume(state) {
  return {
    pending: state.CoinsPending,
    claimed: state.CoinsClaimed,
    banked: state.CoinsBanked,
    modules: state.CoinsByModule,
  };
}

export function getRankingData(state) {
  return state.rankingData;
}

export function getUserPosition(state) {
  return state.userPosition;
}

export function getModulesData(state) {
  let modules = {};
  state.CoinsByModule.forEach((element) => {
    modules[element.order] = element;
  });
  let response = [
    {
      title: 'Organization',
      img: 'modules-01',
      order: 1,
      alt: 'Organization icon',
      state: modules['1'].unlocked,
      totalPoints: modules['1'].Points,
      claimed: modules['1'].pointsClaimed,
      pending: modules['1'].pointsPending,
      banked: modules['1'].pointsBanked,
    },
    {
      title: 'Homework Recording',
      img: 'modules-02',
      order: 2,
      alt: 'Homework Recording icon',
      state: modules['2'].unlocked,
      totalPoints: modules['2'].Points,
      claimed: modules['2'].pointsClaimed,
      pending: modules['2'].pointsPending,
      banked: modules['2'].pointsBanked,
    },
    {
      title: 'Homework Completion',
      img: 'modules-03',
      order: 3,
      alt: 'Homework Completion icon',
      state: modules['3'].unlocked,
      totalPoints: modules['3'].Points,
      claimed: modules['3'].pointsClaimed,
      pending: modules['3'].pointsPending,
      banked: modules['3'].pointsBanked,
    },
    {
      title: 'Time Management',
      img: 'modules-04',
      alt: 'Time Management icon',
      order: 4,
      state: modules['4'].unlocked,
      totalPoints: modules['4'].Points,
      claimed: modules['4'].pointsClaimed,
      pending: modules['4'].pointsPending,
      banked: modules['4'].pointsBanked,
    },
  ];
  return response;
}

export function getProgressRange(state) {
  return state.progressRange;
}

export function getProgress(state) {
  return state.progressInfo;
}

export function getProgressDays(state) {
  return state.progressDays;
}

export function getProgressModules(state) {
  return state.progressInfoModules;
}

export function getPendingCoinsDetail(state) {
  return state.pendingCoins;
}

export function getCoinsValue(state) {
  return state.typeCoinsValues;
}

export function getDetailCoin(state) {
  //console.log("GetCoin")
  return (id) => {
    let toreturn = {};
    state.pendingCoins.forEach((element) => {
      if (element.id == id) {
        toreturn = element;
      }
    });
    return toreturn;
  };
}
